<div class="adev-footer-container">
  <div class="adev-footer-columns">
    <div>
      <h2>소셜 미디어</h2>
      <ul>
        <li>
          <a [href]="ngLinks.MEDIUM" title="Angular 블로그">블로그</a>
        </li>
        <li>
          <a [href]="ngLinks.X" title="X (formerly Twitter)">X (Twitter)</a>
        </li>
        <li>
          <a [href]="ngLinks.BLUESKY" title="Bluesky">Bluesky</a>
        </li>
        <li>
          <a [href]="ngLinks.YOUTUBE" title="YouTube">YouTube</a>
        </li>
        <li>
          <a [href]="ngLinks.DISCORD" title="Angular 커뮤니티 Discord 서버에서 토론에 참여하세요.">
            Discord
          </a>
        </li>
        <li>
          <a [href]="ngLinks.GITHUB" title="GitHub">GitHub</a>
        </li>
        <li>
          <a
            [href]="ngLinks.STACKOVERFLOW"
            title="Stack Overflow에서 Angular 기술 질문에 대한 커뮤니티의 답변을 확인하세요."
          >
            Stack Overflow
          </a>
        </li>
      </ul>
    </div>
    <div>
      <h2>커뮤니티</h2>
      <ul>
        <li>
          <a
            href="https://github.com/angular/angular/blob/main/CONTRIBUTING.md"
            title="Angular에 기여하기"
          >
            기여하기
          </a>
        </li>
        <li>
          <a
            href="https://github.com/angular/code-of-conduct/blob/main/CODE_OF_CONDUCT.md"
            title="서로 존중하며 소통합니다."
          >
            행동강령
          </a>
        </li>
        <li>
          <a
            href="https://github.com/angular/angular/issues"
            title="GitHub에 이슈와 제안을 남겨주세요."
          >
            이슈 제보하기
          </a>
        </li>
        <li>
          <a
            href="https://devlibrary.withgoogle.com/products/angular?sort=updated"
            title="Google's DevLibrary"
          >
            Google's DevLibrary
          </a>
        </li>
        <li>
          <a
            href="https://developers.google.com/community/experts/directory?specialization=angular"
            title="Angular Google Developer Experts"
          >
            Angular Google Developer Experts
          </a>
        </li>
      </ul>
    </div>
    <div>
      <h2>리소스</h2>
      <ul>
        <li>
          <a routerLink="/press-kit" title="언론 연락처, 로고 및 브랜드 자료">프레스 키트</a>
        </li>
        <li>
          <a routerLink="/roadmap" title="로드맵">로드맵</a>
        </li>
      </ul>
    </div>
    <div>
      <h2>언어별 가이드</h2>
      <ul>
        <!-- Sorted using Unicode Collation Algorithm (UCA) -->
        <li>
          <a href="https://angular.az/" title="Azərbaycanca">Azərbaycanca</a>
        </li>
        <li>
          <a href="https://docs.angular.lat/" title="Español">Español</a>
        </li>
        <li>
          <a href="https://ilyoskhuja.github.io/angular-uz/" title="Oʻzbekcha">Oʻzbekcha</a>
        </li>
        <li>
          <a href="https://angular-docs.tr/" title="Türkçe">Türkçe</a>
        </li>
        <li>
          <a href="https://angular-docs.ru/" title="Русский">Русский</a>
        </li>
        <li>
          <a href="https://angular.kr/" title="한국어">한국어</a>
        </li>
        <li>
          <a href="https://angular.jp/" title="日本語版">日本語版</a>
        </li>
        <li>
          <a href="https://angular.cn/" title="简体中文版">简体中文版</a>
        </li>
        <li>
          <a href="https://dev.angular.tw/" title="正體中文版">正體中文版</a>
        </li>
      </ul>
    </div>
  </div>
  <p class="docs-license">
    Super-powered by Google ©2010-2026. Code licensed under an
    <a routerLink="/license" title="라이선스 전문">MIT-style License</a>
    . Documentation licensed under
    <a href="https://creativecommons.org/licenses/by/4.0/">CC BY 4.0</a>
    . Built by Angular at v{{ angularVersion }}.
  </p>
</div>
